var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFmhLinkedinSquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8571 3H5.14286C3.96 3 3 3.96 3 5.14286V18.8571C3 20.04 3.96 21 5.14286 21H18.8571C20.04 21 21 20.04 21 18.8571V5.14286C21 3.96 20.04 3 18.8571 3ZM8.57143 9.85714V18H6V9.85714H8.57143ZM6 7.48714C6 6.88714 6.51429 6.42857 7.28571 6.42857C8.05714 6.42857 8.54143 6.88714 8.57143 7.48714C8.57143 8.08714 8.09143 8.57143 7.28571 8.57143C6.51429 8.57143 6 8.08714 6 7.48714ZM18 18H15.4286C15.4286 18 15.4286 14.0314 15.4286 13.7143C15.4286 12.8571 15 12 13.9286 11.9829H13.8943C12.8571 11.9829 12.4286 12.8657 12.4286 13.7143C12.4286 14.1043 12.4286 18 12.4286 18H9.85714V9.85714H12.4286V10.9543C12.4286 10.9543 13.2557 9.85714 14.9186 9.85714C16.62 9.85714 18 11.0271 18 13.3971V18Z",
    fill: "#00182F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmhLinkedinSquare);
export default __webpack_public_path__ + "static/media/fmh-linkedin-square.53da0b934118bf556bb81f932f4fc8b5.svg";
export { ForwardRef as ReactComponent };